import React from 'react';
import { Flex, theme, Typography } from 'antd';

/* Flex rows rather than an antd Table: the rows are form fields and alerts, not tabular data. */

type TWrapperProps = React.PropsWithChildren<{ rootClassName?: string }>;

const TWrapper = ({ rootClassName, children }: TWrapperProps) => (
  <Flex vertical className={rootClassName}>
    {children}
  </Flex>
);

type TSectionHeaderProps = { text?: string };

const TSectionHeader = ({ text = '' }: TSectionHeaderProps) => {
  const { token } = theme.useToken();
  return (
    <div
      style={{
        paddingTop: token.paddingXL, // FIXME: no exact token, the theme used 2.5rem
        paddingBottom: token.paddingXS,
        paddingInline: token.padding,
        backgroundColor: token.colorFillQuaternary,
      }}
    >
      <Typography.Text type="secondary" style={{ fontSize: token.fontSizeSM, textTransform: 'uppercase' }}>
        {text}
      </Typography.Text>
    </div>
  );
};

const TRow = ({ children }: React.PropsWithChildren) => {
  const { token } = theme.useToken();
  return (
    <Flex
      align="center"
      style={{ paddingInline: token.padding, borderBottom: `${token.lineWidth}px solid ${token.colorBorderSecondary}` }}
    >
      {children}
    </Flex>
  );
};

type TCellProps = React.PropsWithChildren<{
  addClass?: string;
}>;

const TCell = ({ addClass, children }: TCellProps) => (
  <div className={addClass} style={{ flex: 1 }}>
    {children}
  </div>
);

export { TWrapper, TRow, TCell, TSectionHeader };
